import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { UserService } from '../../services/user.service';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepicker, MatCalendar } from '@angular/material/datepicker';
import { CalendarService } from '../../services/calendar.service';


declare let $: any;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  public username: string; 

  constructor(
    public userSvc: UserService,
    private router: Router,
    private apiSvc: ApiService,
    private datePicker: MatNativeDateModule,
    public calendarSvc: CalendarService
  ) { }

  ngOnInit() {
    this.username = this.userSvc.getUserName(); 
  }

  public logOut() {

    var response = this.apiSvc.post<any>("api/account/logout", null);

      response.subscribe(
          data => {
            console.log("Logged out");

            this.apiSvc.logOut();
            this.router.navigate(['/login']);

          },
          err => {
            console.log(err);
            this.apiSvc.logOut();
            this.router.navigate(['/login']);
          }
      );

  } 

  // public forceDropdownOpen(e: any) {
  //   // console.log("stopPropagation")
  //   e.stopPropagation();
  // }

  // private forceDropdownClosed() {
  //   $("#main-container").click();
  //   // $("#page-header-themes-dropdown-calendar").dropdown("toggle");
  // }

}
